const PROJECT_SCOPED_PATH = /^\/projects\/[^/]+/

// Project ids are tenant-scoped, so a project deep link requested under one tenant does not exist
// under the tenant the user ends up choosing.
export const resolveTenantReturnPath = (requestedPath: string | undefined): string => {
  if (!requestedPath) return '/'
  if (requestedPath.startsWith('/select-tenant')) return '/'
  if (PROJECT_SCOPED_PATH.test(requestedPath)) return '/'
  return requestedPath
}
